'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var MarketAnalysisGridService = function MarketAnalysisGridService($rootScope, MarketProductGroupGridTransformerFactory, MarketAnalysisGridTransformerFactory, ServiceClassGridTransformerFactory, reoptimizationService, mergeScenarioDataService, reoptPreviewDataUtilsService) {
  function update(rowsInGrid, newRows, gridId, TransformerFactory) {
    var transformedRows = new TransformerFactory().transform({
      domain: newRows
    });
    var dirtyProductionRows = mergeScenarioDataService.mergePreviewScenario(rowsInGrid, transformedRows, gridId);
    if (!_.isEmpty(dirtyProductionRows)) {
      $rootScope.$broadcast('grid:loadedDataChanged:' + gridId, dirtyProductionRows);
    }
    return rowsInGrid;
  }
  function compareMarketDemandGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, MarketAnalysisGridTransformerFactory);
  }
  function compareMarketProductGroupGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, MarketProductGroupGridTransformerFactory);
  }
  function compareMarketServicesGridRows(rowsInGrid, newRows, gridId) {
    return update(rowsInGrid, newRows, gridId, ServiceClassGridTransformerFactory);
  }
  function resetPDDGrid() {
    $rootScope.$broadcast('grid:clearSelection');
  }
  function filterRowsByMarketDemandId(gridLoadedData, previewingRow) {
    if (previewingRow.marketDemandId) {
      return _.filter(gridLoadedData, {
        marketDemandId: previewingRow.marketDemandId
      });
    } else {
      return _.filter(gridLoadedData, {
        carrier: previewingRow.carrier,
        posName: previewingRow.posName,
        market: previewingRow.origin + '-' + previewingRow.destination,
        departureDate: previewingRow.departureDate
      });
    }
  }
  function filterRowsByOriginDestinationDptrDate(gridLoadedData, previewingRow) {
    return _.filter(gridLoadedData, {
      origin: previewingRow.origin,
      destination: previewingRow.destination,
      departureDate: previewingRow.departureDate
    });
  }
  function updateReoptMarketDemand(gridId, jqxGridSettings, previewingRow) {
    reoptimizationService.getMarketDemand([previewingRow], gridId).then(function (rowsFromServer) {
      if (rowsFromServer.flattenedAggregatedMarketDemand.length > 0) {
        compareMarketDemandGridRows(filterRowsByMarketDemandId(jqxGridSettings.source.loadedData, previewingRow), rowsFromServer, gridId);
      } else {
        toastr.error('Reoptimized market demand are not available.');
      }
    });
  }
  function updateReoptMarketProducts(gridId, jqxGridSettings, previewingRow) {
    reoptimizationService.getMarketDemandClassGroups([previewingRow], gridId).then(function (rowsFromServer) {
      if (rowsFromServer.flattenedAggregatedMarketDemand.length > 0) {
        compareMarketProductGroupGridRows(filterRowsByMarketDemandId(jqxGridSettings.source.loadedData, previewingRow), rowsFromServer, gridId);
      } else {
        toastr.error('Reoptimized market products are not available.');
      }
    });
  }
  function updateReoptMarketServices(gridId, jqxGridSettings, previewingRow, reoptPreviewData) {
    reoptimizationService.getMarketServices([previewingRow], gridId, reoptPreviewData).then(function (rowsFromServer) {
      if (rowsFromServer.serviceClassPOS.length > 0) {
        var rowsInGrid = jqxGridSettings.source.loadedData;
        if (!reoptPreviewData || !reoptPreviewDataUtilsService.getServiceIdsSearchCriteriaRule(reoptPreviewData)) {
          rowsInGrid = filterRowsByOriginDestinationDptrDate(jqxGridSettings.source.loadedData, previewingRow);
        }
        compareMarketServicesGridRows(rowsInGrid, rowsFromServer, gridId);
      } else {
        toastr.error('Reoptimized services are not available.');
      }
    });
  }
  function updateReoptPreviewRows(gridId, jqxGridSettings, previewingRow, reoptPreviewData) {
    switch (gridId) {
      case 'market-demand-analysis':
        return updateReoptMarketDemand(gridId, jqxGridSettings, previewingRow);
      case 'market-product-group-analysis':
        return updateReoptMarketProducts(gridId, jqxGridSettings, previewingRow);
      case 'service-demand-analysis':
        return updateReoptMarketServices(gridId, jqxGridSettings, previewingRow);
      case 'service-flight-analysis':
        return updateReoptMarketServices(gridId, jqxGridSettings, previewingRow, reoptPreviewData);
    }
  }
  return {
    resetPDDGrid: resetPDDGrid,
    updateReoptPreviewRows: updateReoptPreviewRows
  };
};
MarketAnalysisGridService.$inject = ['$rootScope', 'MarketProductGroupGridTransformerFactory', 'MarketAnalysisGridTransformerFactory', 'ServiceClassGridTransformerFactory', 'ReoptimizationService', 'MergeScenarioDataService', 'ReoptPreviewDataUtilsService'];
module.exports = MarketAnalysisGridService;